<template>
  <div>
    <h1>Urlaubsübersicht</h1>
    <router-link class="btn btn-outline-info" :to="{ path: 'leaves/leaveCreate' }">Urlaub Hinzufügen</router-link>
    <br />
    <br />
    <div v-if="leaves.length > 0">
      <table class="table">
        <tr>
          <td>Nutzer</td>
          <td>Zeitraum</td>
          <td>Urlaubstag</td>
          <td>Beschreibung</td>
          <td>Status</td>
          <td></td>
          <td v-if="adminAccess">Aktion</td>
        </tr>
        <tbody v-for="leave in leaves" :key="leave.id">
          <LeavesRow :leave="leave" :leaveDaysObj="leaveDayCalculation(leave.from, leave.to)"
            @deleteLeave="deleteLeave" />
        </tbody>
      </table>
      <div>
      </div>
    </div>
    <div v-else>
      Keine Urlaube gefunden.
    </div>
  </div>
</template>

<style>
.home {
  display: flex;
  align-items: center;
  flex-direction: column;
}
</style>

<script>
import { mapGetters, mapState } from "vuex";
import axios from "axios";
import moment from "moment";
import LeavesRow from "./leavesRow.vue";


export default {
  components: {
    LeavesRow,
  },
  name: "leaves",
  data() {
    return {
      leaves: [],
      holidays: [],
      illness: [],

      moment: moment,
    };
  },
  computed: {
    ...mapGetters(["isAuthenticated", "authStatus", "getProfile"]),
    ...mapState({
      adminAccess: state => state.user.profile.adminAccess,
    }),
  },
  methods: {

    leaveDayCalculation(from, to) {
      const fromDate = new Date(from);
      const toDate = new Date(to);
      let leavesAvailed = 0;
      let holidayCount = 0;
      let weekendCount = 0;
      let illnessCount = 0;
      let totalDays = 0;

      for (let d = new Date(fromDate); d <= toDate; d.setDate(d.getDate() + 1)) {
        if (!this.isWeekend(d.getDay())) {
          if (this.isIllness(d)) {
            illnessCount++;
          } else {
            const holiday = this.isHoliday(d);
            if (holiday) {
              holidayCount += holiday.percentage;
            } else {
              leavesAvailed++;
            }
          }
        } else {
          weekendCount++;
        }
      }

      totalDays = leavesAvailed + holidayCount + weekendCount + illnessCount;

      return {
        totalDays: totalDays,
        leavesAvailed: leavesAvailed,
        weekendCount: weekendCount,
        illnessCount: illnessCount,
        description: `Total days: ${totalDays}, leaves: ${leavesAvailed}, holidays: ${holidayCount}, weekends: ${weekendCount}`,
      };
    },


    isWeekend(day) {
      return day === 0 || day === 6;
    },

    isHoliday(date) {
      const dateStr = this.formatDateWithoutTime(date);
      return this.holidays.find(h => {
        const holidayDate = new Date(h.date);
        const holidayDateStr = this.formatDateWithoutTime(holidayDate);
        return holidayDateStr === dateStr;
      });
    },

    isIllness(date) {
      return this.illness.some(i => {
        const illnessFrom = new Date(i.from);
        const illnessTo = new Date(i.to);
        return date >= illnessFrom && date <= illnessTo;
      });
    },

    formatDateWithoutTime(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');

      return `${year}-${month}-${day}`;
    },

    deleteLeave: function (leaveId) {
      var indexToRemove = -1;
      for (var i = 0; i < this.leaves.length; i++) {
        if (this.leaves[i].id == leaveId) {
          indexToRemove = i;
        }
      }
      this.leaves.splice(indexToRemove, 1);
    },

    getHolidays() {
      axios({ method: "GET", url: process.env.VUE_APP_API_PATH + "holidays" }).then(result => {
        this.holidays = result.data;
        this.getIllnesses();

      }, error => {
        console.error(error);
        if (error.response.status == 401) {
          this.$router.push("/");
        }
      });
    },

    getIllnesses() {
      axios({ method: "GET", url: process.env.VUE_APP_API_PATH + "illnesses/get" }).then(result => {
        this.illness = result.data;
        this.getLeaves();
      }, error => {
        console.error(error);
        if (error.response.status == 401) {
          this.$router.push("/");
        }
      });
    },

    getLeaves() {
      axios({ method: "GET", url: process.env.VUE_APP_API_PATH + "leaves/get" }).then(result => {
        this.leaves = result.data;
      }, error => {
        console.error(error);
        if (error.response.status == 401) {
          this.$router.push("/");
        }
      });
    },
  },

  mounted() {
    this.getHolidays();

  }

};


</script>
